import { Button, InputAdornment, Modal, TextField } from '@mui/material';
import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import request from '../../../Helpers/API';
import { LoaderScreen } from '../../components/LoaderScreen';

export const ModalPromociones = ({ open, handleClose, datos, ObtenerListado }) => {
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [promocion, setPromocion] = useState({ descripcion: "", vigencia: "" });

    useEffect(() => {
        if (open) {
            onBuscar();
        } else {
            // Limpiar promocion al cerrar el modal
            setPromocion({ descripcion: "" });
        }
    }, [open]);

    const onBuscar = () => {
        request
            .get(`Inventario/ObtenerPromocion?idinventario=${datos.idinventario}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });

                // Asegurar que vigencia está en el formato correcto (YYYY-MM-DD)
                const vigenciaFormateada = result.vigencia ? new Date(result.vigencia).toISOString().split('T')[0] : "";

                setPromocion({
                    ...result,
                    vigencia: vigenciaFormateada
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire({
                    title: "Error",
                    text: JSON.stringify(error),
                    icon: "error"
                });
            });
    };


    const handleChange = (e) => {
        setPromocion({ ...promocion, descripcion: e.target.value }); // Actualiza el valor de descripcion al escribir
    };
    const handleDateChange = (e) => {
        setPromocion({ ...promocion, vigencia: e.target.value }); // Actualiza el valor de vigencia
    };

    const onGuardar = () => {

        const post = {
            idpromocion: promocion.idpromocion,
            idinventario: promocion.idinventario,
            descripcion: promocion.descripcion,
            vigencia: promocion.vigencia,
        }

        request
            .post("Inventario/GuardarPromocion", post)
            .then(async () => {
                setLoader({ ...loader, mostrar: false });
                handleClose();
                Swal.fire("PROMOCIONES", "Promocion modificada con éxito", "success");
                ObtenerListado();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("PROMOCIONES", JSON.stringify(error), "error");
            });
    };

    const onEliminar = () => {
        // console.log(formData)

        request
            .get(`Inventario/BorrarPromocion?idpromocion=${promocion.idpromocion}`)
            .then(async () => {
                setLoader({ ...loader, mostrar: false });
                handleClose();
                Swal.fire("PROMOCIONES", "Promocion eliminada con éxito", "success");
                ObtenerListado();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("PROMOCIONES", JSON.stringify(error), "error");
            });
    };
    return (
        <Modal open={open}>
            <div className="otros-modal">
                <LoaderScreen loader={loader} />
                <div className="otros-modal-title">
                    <div className="filtro-soy-el-titulo-header">
                        <h3>MODIFICAR PROMOCION</h3>
                    </div>
                </div>
                <div className="imagen-modal-soy-el-titulo-line">
                    <div className="imagen-modal-soy-el-titulo-line-bl"></div>
                    <div className="imagen-modal-soy-el-titulo-line-circle"></div>
                    <div className="imagen-modal-soy-el-titulo-line-br"></div>
                </div>

                <div className='Modal-Promociones-inputs-Container'>
                    <div className="">
                        <TextField
                            id="promocion"
                            label="Promoción"
                            type="text"
                            value={promocion?.descripcion} // Mostrar comas mientras escribe
                            onChange={handleChange}
                            sx={{ mb: 2, width: 540 }}
                        />
                    </div>
                    <div>
                        <TextField
                            id="vigencia"
                            label="Vigencia"
                            type="date"
                            value={promocion.vigencia}
                            onChange={handleDateChange}
                            sx={{ mb: 2, width: 540 }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </div>
                </div>
                <div className="promociones-modal-button-container">
                    <div className="cerrar-button" onClick={handleClose} style={{ cursor: "pointer" }}>
                        Cerrar
                    </div>
                    <div className="right-buttons">
                        <div className="eliminar-button"
                            onClick={onEliminar}
                            style={{ cursor: "pointer" }}>
                            Eliminar
                        </div>
                        <div className="agregar-button"
                            onClick={onGuardar}
                            style={{ cursor: "pointer" }}>
                            Modificar
                        </div>
                    </div>
                </div>

            </div>
        </Modal>
    )
};